import { SignOutButton } from "@/components/AuthButtons";
import { Persona } from "@/components/Persona";
import { LinkedId } from "@/server/backend-api/linkedUniversities";
import { mcn } from "@/utils/mergeClassNames";
import { Menu } from "@headlessui/react";
import { ProfileData } from "../../types";
import { UserMenuItem } from "./UserMenuItem";

type Props = {
  profile: ProfileData | null;
  linkedIds: LinkedId[] | null;
};

const userMenuItems = (props: Props) => {
  const items = [
    { label: "Home", href: "/" },
    { label: "Competence Passport", href: "/passport" },
    { label: "Contracts", href: "/company" },
  ];
  if (!props.profile?.isCorporateTrainingManager) {
    return items.filter((item) => item.label !== "Contracts");
  }

  return items;
};
export const UserMenuContentMobile = (props: Props) => {
  const menuItems = userMenuItems(props);
  return (
    <>
      <ul>
        {menuItems.map((item, index) => (
          <li key={index}>
            <UserMenuItem href={item.href} label={item.label} mobile={true} />
          </li>
        ))}
      </ul>
      <Menu.Item>
        {({ active }) => (
          <SignOutButton
            className={mcn(
              "mx-md mt-sm rounded-3 h-[40px]",
              active && "default-focus"
            )}
          />
        )}
      </Menu.Item>
      <div className="mx-md my-xl border-b border-white " />
    </>
  );
};

export const UserMenuContentDesktop = (props: Props) => {
  const menuItems = userMenuItems(props);
  return (
    <>
      <div>
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              <UserMenuItem href={item.href} label={item.label} />
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-auto p-lg space-y-lg">
        <Persona
          displayName={props.profile?.displayName}
          imageUrl={"/api/profilePhoto/me"}
          href={"/profile"}
          verified={props.linkedIds?.some((id) => id.isVerified) ?? false}
        />
        <SignOutButton />
      </div>
    </>
  );
};
